(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
      this.stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};
      this.header.dataset.mobileStickyController = 'existing-header-fixed-v1';
      this.setHeaderHeight();
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.onBreakpointChangeHandler = this.onBreakpointChange.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.setStickyMode();
      if (this.mobileMediaQuery.matches) this.updateMobileStickyState(window.pageYOffset || document.documentElement.scrollTop);
      if (this.mobileMediaQuery.addEventListener) this.mobileMediaQuery.addEventListener('change', this.onBreakpointChangeHandler);
      else this.mobileMediaQuery.addListener(this.onBreakpointChangeHandler);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      document.addEventListener('scroll', this.onScrollHandler, true);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setStickyMode() {
      if (this.mobileMediaQuery.matches) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      } else if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
      }
    }

    onBreakpointChange() {
      this.setHeaderHeight();
      if (this.mobileMediaQuery.matches) {
        this.setStickyMode();
        this.updateMobileStickyState(window.pageYOffset || document.documentElement.scrollTop);
        return;
      }
      this.header.classList.remove('mobile-header-sticky');
      if (!this.headerIsAlwaysSticky) {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }

    disconnectedCallback() {
      if (this.mobileMediaQuery.removeEventListener) this.mobileMediaQuery.removeEventListener('change', this.onBreakpointChangeHandler);
      else this.mobileMediaQuery.removeListener(this.onBreakpointChangeHandler);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      document.removeEventListener('scroll', this.onScrollHandler, true);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observerInstance) => {
        this.headerBounds = entries[0].intersectionRect;
        observerInstance.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll(event) {
      const pageScrollTop = window.pageYOffset || document.scrollingElement?.scrollTop || document.documentElement.scrollTop || 0;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (this.mobileMediaQuery.matches) {
        const elementScrollTop = event?.target instanceof Element && !this.header.contains(event.target) ? event.target.scrollTop : 0;
        const scrollTop = Math.max(pageScrollTop, elementScrollTop || 0);
        this.updateMobileStickyState(scrollTop);
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.stickyType === 'none' || (event && event.target !== document && event.target !== document.scrollingElement)) return;
      const scrollTop = pageScrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    updateMobileStickyState(scrollTop) {
      const isSticky = scrollTop > 0;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.header.classList.toggle('mobile-header-sticky', isSticky);
      this.header.classList.toggle('scrolled-past-header', isSticky);
      this.header.dataset.mobileStickyActive = String(isSticky);
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener('open', (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
    const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
    event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
  }, true);

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
